import "./CompleteReviewModal.css";

import { Dispatch, SetStateAction } from "react";

import { Button, Column, Modal, Row } from "../../../../widget";
import { useCompleteReviewModal } from "./useCompleteReviewModal";

interface CompleteReviewModalProps {
  show: boolean;
  onClose: () => void;
  activityUuid: string;
  activityStatus: string;
  activityRowVersion: number;
  activityReviewUuid: string;
  activityReviewStatus: string;
  activityReviewRowVersion: number;
  activityAssessmentUuid: string;
  activityAssessmentStatus: string;
  activityAssessmentRowVersion: number;
  refreshActivityReviews?: boolean;
  setRefreshActivityReviews?: Dispatch<SetStateAction<boolean>>;
  exitActivityReviewWizard?: () => void;
}

export const CompleteReviewModal = ({
  show,
  onClose,
  activityUuid,
  activityStatus,
  activityRowVersion,
  activityReviewUuid,
  activityReviewStatus,
  activityReviewRowVersion,
  activityAssessmentUuid,
  activityAssessmentStatus,
  activityAssessmentRowVersion,
  refreshActivityReviews,
  setRefreshActivityReviews,
  exitActivityReviewWizard,
}: CompleteReviewModalProps): JSX.Element => {
  const { isLoading, onConfirmClick } = useCompleteReviewModal({
    activityUuid,
    activityStatus,
    activityRowVersion,
    onClose,
    activityReviewUuid,
    activityReviewStatus,
    activityReviewRowVersion,
    activityAssessmentUuid,
    activityAssessmentStatus,
    activityAssessmentRowVersion,
    refreshActivityReviews,
    setRefreshActivityReviews,
    exitActivityReviewWizard,
  });

  return (
    <Modal show={show} title="Complete review" onClose={onClose}>
      <Row spacingV="ll" justify="center">
        <Column span={10}>
          <span className="body1">
            Completing the review will notify the Manager that the process has complete and they can return the
            responses to the Developer.
          </span>
        </Column>
      </Row>
      <Row justify="center">
        <Column span={6}>
          <div className="CompleteReviewModalButtons">
            <Button text="Complete review" onClick={onConfirmClick} isLoading={isLoading} />
            <Button variant="secondary" text="Cancel" onClick={onClose} />
          </div>
        </Column>
      </Row>
    </Modal>
  );
};
